import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Button, ButtonGroup, ContentSection, Layout, PageWrap, SectionHeading } from '@vwfs-bronson/bronson-react';
import { getBrandName } from '../../../config';
import { CustomerType } from '../../../resources/base/models/enums';
import { Analytics } from '../../../services/analytics';
import { customerContactDataEvent } from '../../../services/analytics/analyticsEvents';
import { customerSelectors, resetCustomer, setCustomerType } from '../../../services/redux/features/customer.slice';
import { quoteSelectors } from '../../../services/redux/features/quote.slice';
import { useNavigate } from '../../../services/routing/navigate';

export const SelectCustomerType: FunctionComponent = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  /**
   * Customer type existing in Back Office (BO).
   */
  const quoteCustomerType = useSelector(quoteSelectors.selectCustomerTypeFromQuote);
  /**
   * Customer type in application memory - not necessarily submitted to BO yet.
   */
  const customerType = useSelector(customerSelectors.selectCustomerType);

  const onChooseCustomerType = (customerType: CustomerType) => {
    dispatch(setCustomerType(customerType));
    Analytics.push(customerContactDataEvent(customerType));
    navigate.form(2);
  };

  return (
    <PageWrap>
      <ContentSection altBackground={getBrandName().includes('vw')} className="u-pv-none">
        <SectionHeading center level={2}>
          {t('step2:heading:customerType')}
        </SectionHeading>
        <ButtonGroup buttonGroupType="checkbox">
          <ButtonGroup.Item
            buttonGroupItemIcon="user"
            index="1"
            handle="standalone"
            defaultChecked={customerType === CustomerType.INDIVIDUAL}
            onClick={() => {
              if (quoteCustomerType !== CustomerType.INDIVIDUAL) {
                dispatch(resetCustomer());
              }
              onChooseCustomerType(CustomerType.INDIVIDUAL);
            }}
          >
            {t('step2:privateCustomerButton:label')}
          </ButtonGroup.Item>
          <ButtonGroup.Item
            buttonGroupItemIcon="briefcase"
            index="2"
            handle="standalone"
            defaultChecked={customerType === CustomerType.LEGAL_ENTITY}
            onClick={() => {
              if (quoteCustomerType !== CustomerType.LEGAL_ENTITY) {
                dispatch(resetCustomer());
              }
              const customerToPick = CustomerType.LEGAL_ENTITY;
              onChooseCustomerType(customerToPick);
            }}
          >
            {t('step2:businessCustomerButton:label')}
          </ButtonGroup.Item>
        </ButtonGroup>
      </ContentSection>
      <ContentSection pageWrapSize="small">
        <Layout center>
          <Layout.Item default="1/3">
            <Button type="button" secondary full onClick={() => navigate.form('/1')}>
              {t('step2:navigation:return')}
            </Button>
          </Layout.Item>
        </Layout>
      </ContentSection>
    </PageWrap>
  );
};
